<template>
  <div>
    <div class="mt-4 buttons-for-toggle d-flex flex-wrap">
      <b-button
        v-for="(type, index) in types"
        :key="index"
        squared
        :variant="toggleType === type ? 'primary' : 'outline-primary'"
        @click="changeSelectionForToggle(type)"
        class="button-no-map d-flex justify-content-between"
      >{{ tabTitles[index] }}
        <em
          class="fas fa-chevron-circle-down mt-1"
          v-if="toggleType !== type"
        ></em>
        <em class="fas fa-chevron-circle-up mt-1" v-else></em>
      </b-button>
    </div>
    <b-collapse id="collapse-for-classes" class="mt-2">
      <b-card>
        <b-card
          no-body
          class="mb-1"
          v-for="(classOrUniver, index) in dataForToggles"
          :key="index"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              href="#"
              class="text-justify"
              @click="
                        $root.$emit('bv::toggle::collapse', 'accordion-' + index)
                      "
              variant="outline-primary"
            ><strong>{{ classOrUniver.title }}</strong></b-button
            >
          </b-card-header>
          <b-collapse
            :id="'accordion-' + index"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card-text v-if="classOrUniver.address">
                Адрес: {{ classOrUniver.address }}
              </b-card-text>
              <b-card-text v-if="classOrUniver.description">
                {{ classOrUniver.description }}
              </b-card-text>
              <b-card-text v-if="toggleType === 'classes'">
                Организация:
                <a
                  v-for="(sub, orgIndex) in classOrUniver.subdivisions"
                  :key="orgIndex"
                  :href="sub.siteUrl"
                  target="_blank"
                >
                  {{ sub.title }}
                  {{
                    orgIndex != classOrUniver.subdivisions.length - 1
                      ? ', '
                      : ''
                  }}
                </a>
              </b-card-text>
              <b-card-text v-if="toggleType === 'classes'"
              >Год открытия: {{ classOrUniver.year }}</b-card-text
              >
              <b-button
                variant="outline-primary"
                @click="goToOrganisationPage(classOrUniver)"
              >Перейти к странице</b-button
              >
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'OrgCollapses',
  props: {
    types: {
      type: Array,
      default() {
        return []
      }
    },
    tabTitles: {
      type: Array,
      default() {
        return []
      }
    },
    toggleType: {
      type: String,
      default() {
        return 'classes'
      }
    },
    dataForToggles: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    goToOrganisationPage(object) {
      if (this.toggleType === 'fields') {
        window.open(object.siteUrl, '_blank')
      } else {
        this.$router.push(
          (this.toggleType === 'classes'
            ? '/gazprom-classes/'
            : '/gazprom-universities/')
          + object.contentObject.id,
        )
      }
    },
    changeSelectionForToggle(type) {
      this.$emit('toggle', type)
    }
  }
}
</script>

<style scoped>
.button-no-map {
  width: 180px;
  padding: 10px 15px;
  text-align: justify;
}
@media screen and (max-width: 600px) {
  .button-no-map {
    width: 100%;
  }
}
</style>
